import { Component, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';
import { WebServicesService } from 'src/app/container/internal/internal-home/pages/webservices/webservices.service';
import { HomeExternalService } from 'src/app/container/external/shared/home/home-external.service';
import { VistaRapida } from 'src/app/core/entities/vistarapida.models';
import * as _ from 'lodash';
@Component({
  selector: 'app-donas',
  templateUrl: './donas.component.html',
  styleUrls: ['./donas.component.scss']
})
export class DonasComponent implements OnInit {

  vistaRapidaInterna: VistaRapida = new VistaRapida();
  vistaRapidaExterna: VistaRapida = new VistaRapida();
  vistaRapidaActivo: VistaRapida = new VistaRapida();

  rebutsPag : number = 0;
  rebutsPenDins : number = 0;
  rebutsPenFora : number = 0;
  rebutsTramits : number = 0;

  public doughnutChartType: ChartType = 'doughnut';

  public doughnutChartData: any = {
    labels: [],
    datasets: [
      {
        data: [0, 0, 0, 0],
        backgroundColor: ['#28a745', '#dc3545', '#007bff', '#fd7e14']
      }
    ]
  };

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
  }

  //public donasChartData: ChartDataSets[] = [];

  constructor(private translateService: TranslateService,
              private webServicesService : WebServicesService,
              private homeExternalService: HomeExternalService) { }

  ngOnInit() {
    if(this.webServicesService.vistaRapidaObj.active){
      this.vistaRapidaActivo =  _.cloneDeep(this.webServicesService.vistaRapidaObj);
      this.actualizarGrafico();
    }

    if(this.homeExternalService.vistaRapidaObj.active){
      this.vistaRapidaActivo =  _.cloneDeep(this.homeExternalService.vistaRapidaObj);
      this.actualizarGrafico();
    }
  }

  actualizarGrafico(): void {

    this.doughnutChartData.datasets[0].data = [
      +this.vistaRapidaActivo.rebutpagat.toFixed(2),
      +this.vistaRapidaActivo.reubupendins.toFixed(2),
      +this.vistaRapidaActivo.reubupenfora.toFixed(2),
      +this.vistaRapidaActivo.tramitantse.toFixed(2)
    ];

    this.rebutsPag = this.vistaRapidaActivo.totRebutPag;
    this.rebutsPenDins = this.vistaRapidaActivo.totRebutPenDins;
    this.rebutsPenFora = this.vistaRapidaActivo.totRebutPenFora;
    this.rebutsTramits = this.vistaRapidaActivo.totRebutTramtit;

    this.doughnutChartData.labels = [
      this.translateService.instant('WSDEFS.wsfi4receiptpaga') +
      ': ' + this.rebutsPag +
      ' - ' +
      this.translateService.instant('TABLAS.importe'),

      this.translateService.instant('WEBSERVICES.VISTA_RAPIDA.REBUTS.pendiente_dins') +
      ': ' + this.rebutsPenDins +
      ' - ' +
      this.translateService.instant('TABLAS.importe'),

      this.translateService.instant('WEBSERVICES.VISTA_RAPIDA.REBUTS.pendiente_fora') +
      ': ' + this.rebutsPenFora +
      ' - ' +
      this.translateService.instant('TABLAS.importe'),

      this.translateService.instant('WEBSERVICES.VISTA_RAPIDA.REBUTS.tramitando') +
      ': ' + this.rebutsTramits +
      ' - ' +
      this.translateService.instant('TABLAS.importe')
    ];
  }

  //event
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    //console.log(event, active);
  }

  //event
  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    //console.log(event, active);
  }

}
